import { useState, useCallback, useContext } from 'react';
import { Slider, Dropdown, Button } from 'antd';
import { CheckOutlined, MoreOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import AvatarActionContext from '../context/avatar-context';
import ZoomContext from '../../../context/zoom-context';
import MediaContext from '../../../context/media-context';
import { getAntdDropdownMenu, getAntdItem } from './video-footer-utils';
import { useSpotlightVideo } from '../hooks/useSpotlightVideo';
import { downloadFile, uploadAsanaImage } from '../../../utils/util';
import { UserRole, ViewContext } from '../../../App';

interface AvatarMoreProps {
  className?: string;
  userId: number;
  isHover: boolean;
}
const isUseVideoPlayer = new URLSearchParams(location.search).get('useVideoPlayer') === '1';
const AvatarMore = (props: AvatarMoreProps) => {
  const { userId, isHover } = props;
  const { avatarActionState, dispatch } = useContext(AvatarActionContext);
  const { mediaStream } = useContext(MediaContext);
  const zmClient = useContext(ZoomContext);
  const cmdClient = zmClient.getCommandClient();
  const viewContext = useContext(ViewContext);
  const [isDropdownVisible, setIsDropdownVisbile] = useState(false);
  const [isControllingRemoteCamera, setIsControllingRemoteCamera] = useState(false);
  useSpotlightVideo(zmClient, mediaStream, (participants) => {
    dispatch({ type: 'set-spotlighted-videos', payload: participants });
  });
  const actionItem = avatarActionState[`${userId}`];
  const { spotlightedUserList } = avatarActionState;
  const menu = [];
  // if (actionItem) {
  //   if (actionItem.localVolumeAdjust.enabled) {
  //     menu.push(
  //       getAntdItem('Adjust volume locally', 'volume', actionItem?.localVolumeAdjust.toggled && <CheckOutlined />)
  //     );
  //   }
  //   if (actionItem?.farEndCameraControl.enabled) {
  //     menu.push(getAntdItem(isControllingRemoteCamera ? 'Give up camera control' : 'Control far end camera', 'farend'));
  //   }
  // }
  if (actionItem?.videoResolutionAdjust.enabled) {
    menu.push(
      getAntdItem(
        'Subscribe other video resolution',
        'subscribeVideoQuality',
        actionItem?.videoResolutionAdjust.toggled && <CheckOutlined />
      )
    );
  }
  const isHostOrManager = zmClient.isHost() || zmClient.isManager();
  if (zmClient.getUser(userId)?.bVideoOn && isHostOrManager) {
    menu.push(getAntdItem('Take screenshot', 'screenshot'));
    // menu.push(getAntdItem('Pin for spotlight', 'pinForSpotlight'));
    // menu.push(getAntdItem('Pin for myself', 'pinForMyself'));
    // menu.push(getAntdItem('Unpin', 'unpin'));
  }
  // console.log("isUseVideoPlayer======", isUseVideoPlayer);
  // if (isUseVideoPlayer) {

  if (isHostOrManager) {
    menu.push(getAntdItem('Pin for spotlight', 'pinForSpotlight'));
    menu.push(getAntdItem('Pin for myself', 'pinForMyself'));
    menu.push(getAntdItem('Unpin', 'unpin'));
  } else {
    menu.push(getAntdItem('Pin for myself', 'pinForMyself'));
    menu.push(getAntdItem('Unpin', 'unpin'));
  }
  // if (true) {
  //   const currentUserId = zmClient.getCurrentUserInfo()?.userId;

  //   console.log("currentUserId======", currentUserId, isHostOrManager);
  //   if (
  //     currentUserId === userId &&
  //     spotlightedUserList?.find((user) => user.userId === currentUserId) &&
  //     spotlightedUserList.length === 1
  //   ) {
  //     menu.push(getAntdItem('Remove spotlight', 'removeSpotlight'));
  //   } else if (isHostOrManager) {
  //     if (spotlightedUserList && spotlightedUserList.findIndex((user) => user.userId === userId) > -1) {
  //       menu.push(getAntdItem('Remove spotlight', 'removeSpotlight'));
  //     } else {
  //       const user = zmClient.getUser(userId);
  //       if (user?.bVideoOn) {
  //         menu.push(getAntdItem('Add spotlight', 'addSpotlight'));
  //         menu.push(getAntdItem('Replace spotlight', 'replaceSpotlight'));
  //       }
  //     }
  //   }
  // }
  const onSliderChange = useCallback(
    (value: any) => {
      mediaStream?.adjustUserAudioVolumeLocally(userId, value);
      dispatch({ type: 'update-local-volume', payload: { userId, volume: value } });
    },
    [userId, mediaStream, dispatch]
  );
  const onDropDownVisibleChange = useCallback((visible: boolean) => {
    setIsDropdownVisbile(visible);
  }, []);
  const currentRole = zmClient.getCurrentUserInfo()?.userIdentity?.slice(0, 1);
  const participants = zmClient.getAllUser();
  const setMainViewForContext = () => {
    const currentRole = zmClient.getCurrentUserInfo()?.userIdentity?.slice(0, 1);
    const participants = zmClient.getAllUser();
    if (currentRole === UserRole.Student) {
      console.log('currentRole----', currentRole);
      const userWithRoleInstructor = participants.find(
        (user) => user.userIdentity?.slice(0, 1) === UserRole.Instructor
      );
      if (userWithRoleInstructor) {
        console.log('userWithRoleInstructor', userWithRoleInstructor);
        viewContext.setMainViewUser(userWithRoleInstructor);
      }
    } else {
      const userWithRoleStudent = participants.find((user) => user.userIdentity?.slice(0, 1) === UserRole.Student);
      if (userWithRoleStudent) {
        console.log('userWithRoleStudent', userWithRoleStudent);
        viewContext.setMainViewUser(userWithRoleStudent);
      }
    }
  };

  const onMenuItemClick = useCallback(
    ({ key }: { key: string }) => {
      if (key === 'volume') {
        dispatch({ type: 'toggle-local-volume', payload: { userId } });
      } else if (key === 'farend') {
        dispatch({ type: 'toggle-far-end-camera-control', payload: { userId } });
        if (isControllingRemoteCamera) {
          mediaStream?.giveUpFarEndCameraControl(userId);
          dispatch({ type: 'set-is-controlling-remote-camera', payload: false });
        } else {
          mediaStream?.requestFarEndCameraControl(userId);
        }
        setIsControllingRemoteCamera(!isControllingRemoteCamera);
      } else if (key === 'subscribeVideoQuality') {
        dispatch({ type: 'toggle-video-resolution-adjust', payload: { userId } });
      } else if (key === 'removeSpotlight') {
        mediaStream?.removeSpotlightedVideo(userId);
      } else if (key === 'addSpotlight') {
        mediaStream?.spotlightVideo(userId, false);
      } else if (key === 'replaceSpotlight') {
        mediaStream?.spotlightVideo(userId, true);
      } else if (key === 'screenshot') {
        mediaStream?.screenshotVideo(userId).then(async (blob) => {
          if (blob) {
            console.log('User ID', userId);
            let participant = zmClient.getUser(userId);
            let userSid = participant?.userIdentity?.slice(1, 35);
            let userName = participant?.displayName;
            console.log('User SID', userSid);

            const now = new Date();
            const timestamp = `${now.getFullYear().toString().slice(-2)}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}_${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;
            const fileName = `meeting_${userName}-${timestamp}.png`;

            // Download to local
            downloadFile(blob as Blob, fileName);

            // Upload to server if userSid exists
            if (userSid) {
              try {
                const formData = new FormData();
                formData.append('reportImage', blob as Blob, fileName);

                await uploadAsanaImage(userSid, formData);
                console.log('Image uploaded successfully to server');
              } catch (error) {
                console.error('Failed to upload image to server:', error);
              }
            }
          }
        });
      } else if (key === 'pinForMyself') {
        viewContext.setGalleryView(true);
        viewContext.setSpeakerView(false);
        // Add delay
        viewContext.setPinViewUser(null);
        viewContext.setMainViewUser(null);
        setTimeout(() => {
          viewContext.setSpeakerView(true);
          viewContext.setGalleryView(false);
          const mainViewUser = zmClient.getUser(userId);
          viewContext.setMainViewUser(mainViewUser);
          viewContext.setPinViewUser(mainViewUser);
          const spotlightUser = zmClient.getUser(userId);
          viewContext.setMainViewUser(spotlightUser);
          viewContext.setPinViewUser(spotlightUser);
        }, 100);
      } else if (key === 'pinForSpotlight') {
        cmdClient?.send(`/spotlight-start_${userId}`);
        viewContext.setGalleryView(true);
        viewContext.setSpeakerView(false);
        // Add delay
        viewContext.setPinViewUser(null);
        viewContext.setMainViewUser(null);
        setTimeout(() => {
          const spotlightUser = zmClient.getUser(userId);
          viewContext.setMainViewUser(spotlightUser);
          viewContext.setPinViewUser(spotlightUser);
          viewContext.setSpeakerView(true);
          viewContext.setGalleryView(false);
        }, 100);
      } else if (key === 'unpin') {
        viewContext.setGalleryView(true);
        viewContext.setSpeakerView(false);
        // Add delay
        viewContext.setPinViewUser(null);
        viewContext.setMainViewUser(null);

        cmdClient?.send(`/spotlight-stop`);
        setTimeout(() => {
          viewContext.setSpeakerView(true);
          viewContext.setGalleryView(false);
          viewContext.setPinViewUser(null);
          setMainViewForContext();
        }, 100);
      }
      setIsDropdownVisbile(false);
    },
    [mediaStream, userId, isControllingRemoteCamera, dispatch]
  );

  return (
    <>
      {menu.length > 0 && (
        <Dropdown
          menu={getAntdDropdownMenu(menu, onMenuItemClick)}
          placement="bottomRight"
          trigger={['click']}
          onOpenChange={onDropDownVisibleChange}
          overlayClassName="shadcn-dropdown"
        >
          <Button
            icon={<MoreOutlined />}
            className={classNames('more-button', {
              'more-button-active': isHover || isDropdownVisible
            })}
            type="primary"
            size="small"
          />
        </Dropdown>
      )}
      {isHover && actionItem?.localVolumeAdjust?.enabled && actionItem?.localVolumeAdjust?.toggled && (
        <div className={classNames('avatar-volume')}>
          <label>Volume:</label>
          <Slider
            marks={{ 0: '0', 100: '100' }}
            defaultValue={100}
            onChange={onSliderChange}
            value={actionItem.localVolumeAdjust.volume}
          />
        </div>
      )}
    </>
  );
};

export default AvatarMore;
